"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/big-file-svc.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigFileServiceClientImpl = exports.BigFileServiceServiceName = exports.FileUploadResponse = exports.FileUploadRequest = exports.DownloadBinDbFileResponse = exports.DownloadBinDbFileRequest = exports.AssociatedEntity = exports.contextualFileTypeToJSON = exports.contextualFileTypeFromJSON = exports.ContextualFileType = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const operators_1 = require("rxjs/operators");
const timestamp_1 = require("../google/protobuf/timestamp");
exports.protobufPackage = "powernode";
var ContextualFileType;
(function (ContextualFileType) {
    ContextualFileType[ContextualFileType["UNKNOWN"] = 0] = "UNKNOWN";
    ContextualFileType[ContextualFileType["SECC"] = 1] = "SECC";
    ContextualFileType[ContextualFileType["CHARGER_SCREENSHOT"] = 2] = "CHARGER_SCREENSHOT";
    ContextualFileType[ContextualFileType["ASYNC_TASK_GENERATED"] = 3] = "ASYNC_TASK_GENERATED";
    ContextualFileType[ContextualFileType["PCAP"] = 4] = "PCAP";
    ContextualFileType[ContextualFileType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ContextualFileType = exports.ContextualFileType || (exports.ContextualFileType = {}));
function contextualFileTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN":
            return ContextualFileType.UNKNOWN;
        case 1:
        case "SECC":
            return ContextualFileType.SECC;
        case 2:
        case "CHARGER_SCREENSHOT":
            return ContextualFileType.CHARGER_SCREENSHOT;
        case 3:
        case "ASYNC_TASK_GENERATED":
            return ContextualFileType.ASYNC_TASK_GENERATED;
        case 4:
        case "PCAP":
            return ContextualFileType.PCAP;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ContextualFileType.UNRECOGNIZED;
    }
}
exports.contextualFileTypeFromJSON = contextualFileTypeFromJSON;
function contextualFileTypeToJSON(object) {
    switch (object) {
        case ContextualFileType.UNKNOWN:
            return "UNKNOWN";
        case ContextualFileType.SECC:
            return "SECC";
        case ContextualFileType.CHARGER_SCREENSHOT:
            return "CHARGER_SCREENSHOT";
        case ContextualFileType.ASYNC_TASK_GENERATED:
            return "ASYNC_TASK_GENERATED";
        case ContextualFileType.PCAP:
            return "PCAP";
        case ContextualFileType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.contextualFileTypeToJSON = contextualFileTypeToJSON;
function createBaseAssociatedEntity() {
    return { entityId: "", entityType: "" };
}
exports.AssociatedEntity = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.entityId !== "") {
            writer.uint32(10).string(message.entityId);
        }
        if (message.entityType !== "") {
            writer.uint32(18).string(message.entityType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAssociatedEntity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.entityId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.entityType = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            entityId: isSet(object.entityId)
                ? globalThis.String(object.entityId)
                : isSet(object.entity_id)
                    ? globalThis.String(object.entity_id)
                    : "",
            entityType: isSet(object.entityType)
                ? globalThis.String(object.entityType)
                : isSet(object.entity_type)
                    ? globalThis.String(object.entity_type)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entityId !== "") {
            obj.entityId = message.entityId;
        }
        if (message.entityType !== "") {
            obj.entityType = message.entityType;
        }
        return obj;
    },
    create(base) {
        return exports.AssociatedEntity.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAssociatedEntity();
        message.entityId = object.entityId ?? "";
        message.entityType = object.entityType ?? "";
        return message;
    },
};
function createBaseDownloadBinDbFileRequest() {
    return {};
}
exports.DownloadBinDbFileRequest = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDownloadBinDbFileRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DownloadBinDbFileRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDownloadBinDbFileRequest();
        return message;
    },
};
function createBaseDownloadBinDbFileResponse() {
    return {
        filename: "",
        chunk: new Uint8Array(0),
        md5sum: new Uint8Array(0),
        size: 0,
    };
}
exports.DownloadBinDbFileResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.filename !== "") {
            writer.uint32(18).string(message.filename);
        }
        if (message.chunk.length !== 0) {
            writer.uint32(50).bytes(message.chunk);
        }
        if (message.md5sum.length !== 0) {
            writer.uint32(58).bytes(message.md5sum);
        }
        if (message.size !== 0) {
            writer.uint32(24).uint64(message.size);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDownloadBinDbFileResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.filename = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.chunk = reader.bytes();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.md5sum = reader.bytes();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.size = longToNumber(reader.uint64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            filename: isSet(object.filename)
                ? globalThis.String(object.filename)
                : "",
            chunk: isSet(object.chunk)
                ? bytesFromBase64(object.chunk)
                : new Uint8Array(0),
            md5sum: isSet(object.md5sum)
                ? bytesFromBase64(object.md5sum)
                : new Uint8Array(0),
            size: isSet(object.size) ? globalThis.Number(object.size) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.filename !== "") {
            obj.filename = message.filename;
        }
        if (message.chunk.length !== 0) {
            obj.chunk = base64FromBytes(message.chunk);
        }
        if (message.md5sum.length !== 0) {
            obj.md5sum = base64FromBytes(message.md5sum);
        }
        if (message.size !== 0) {
            obj.size = Math.round(message.size);
        }
        return obj;
    },
    create(base) {
        return exports.DownloadBinDbFileResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDownloadBinDbFileResponse();
        message.filename = object.filename ?? "";
        message.chunk = object.chunk ?? new Uint8Array(0);
        message.md5sum = object.md5sum ?? new Uint8Array(0);
        message.size = object.size ?? 0;
        return message;
    },
};
function createBaseFileUploadRequest() {
    return {
        filename: "",
        contextualFileType: 0,
        fileContentType: "",
        fileTimeStamp: undefined,
        associatedEntity: undefined,
        chunk: new Uint8Array(0),
        md5sum: new Uint8Array(0),
        size: 0,
    };
}
exports.FileUploadRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.filename !== "") {
            writer.uint32(10).string(message.filename);
        }
        if (message.contextualFileType !== 0) {
            writer.uint32(16).int32(message.contextualFileType);
        }
        if (message.fileContentType !== "") {
            writer.uint32(26).string(message.fileContentType);
        }
        if (message.fileTimeStamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.fileTimeStamp), writer.uint32(34).fork()).join();
        }
        if (message.associatedEntity !== undefined) {
            exports.AssociatedEntity.encode(message.associatedEntity, writer.uint32(42).fork()).join();
        }
        if (message.chunk.length !== 0) {
            writer.uint32(50).bytes(message.chunk);
        }
        if (message.md5sum.length !== 0) {
            writer.uint32(58).bytes(message.md5sum);
        }
        if (message.size !== 0) {
            writer.uint32(64).uint64(message.size);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileUploadRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.filename = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.contextualFileType = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.fileContentType = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.fileTimeStamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.associatedEntity = exports.AssociatedEntity.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.chunk = reader.bytes();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.md5sum = reader.bytes();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.size = longToNumber(reader.uint64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            filename: isSet(object.filename)
                ? globalThis.String(object.filename)
                : "",
            contextualFileType: isSet(object.contextualFileType)
                ? contextualFileTypeFromJSON(object.contextualFileType)
                : isSet(object.contextual_file_type)
                    ? contextualFileTypeFromJSON(object.contextual_file_type)
                    : 0,
            fileContentType: isSet(object.fileContentType)
                ? globalThis.String(object.fileContentType)
                : isSet(object.file_content_type)
                    ? globalThis.String(object.file_content_type)
                    : "",
            fileTimeStamp: isSet(object.fileTimeStamp)
                ? fromJsonTimestamp(object.fileTimeStamp)
                : isSet(object.file_time_stamp)
                    ? fromJsonTimestamp(object.file_time_stamp)
                    : undefined,
            associatedEntity: isSet(object.associatedEntity)
                ? exports.AssociatedEntity.fromJSON(object.associatedEntity)
                : isSet(object.associated_entity)
                    ? exports.AssociatedEntity.fromJSON(object.associated_entity)
                    : undefined,
            chunk: isSet(object.chunk)
                ? bytesFromBase64(object.chunk)
                : new Uint8Array(0),
            md5sum: isSet(object.md5sum)
                ? bytesFromBase64(object.md5sum)
                : new Uint8Array(0),
            size: isSet(object.size) ? globalThis.Number(object.size) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.filename !== "") {
            obj.filename = message.filename;
        }
        if (message.contextualFileType !== 0) {
            obj.contextualFileType = contextualFileTypeToJSON(message.contextualFileType);
        }
        if (message.fileContentType !== "") {
            obj.fileContentType = message.fileContentType;
        }
        if (message.fileTimeStamp !== undefined) {
            obj.fileTimeStamp = message.fileTimeStamp.toISOString();
        }
        if (message.associatedEntity !== undefined) {
            obj.associatedEntity = exports.AssociatedEntity.toJSON(message.associatedEntity);
        }
        if (message.chunk.length !== 0) {
            obj.chunk = base64FromBytes(message.chunk);
        }
        if (message.md5sum.length !== 0) {
            obj.md5sum = base64FromBytes(message.md5sum);
        }
        if (message.size !== 0) {
            obj.size = Math.round(message.size);
        }
        return obj;
    },
    create(base) {
        return exports.FileUploadRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileUploadRequest();
        message.filename = object.filename ?? "";
        message.contextualFileType = object.contextualFileType ?? 0;
        message.fileContentType = object.fileContentType ?? "";
        message.fileTimeStamp = object.fileTimeStamp ?? undefined;
        message.associatedEntity =
            object.associatedEntity !== undefined && object.associatedEntity !== null
                ? exports.AssociatedEntity.fromPartial(object.associatedEntity)
                : undefined;
        message.chunk = object.chunk ?? new Uint8Array(0);
        message.md5sum = object.md5sum ?? new Uint8Array(0);
        message.size = object.size ?? 0;
        return message;
    },
};
function createBaseFileUploadResponse() {
    return { associatedFileId: 0, filename: "", size: 0 };
}
exports.FileUploadResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.associatedFileId !== 0) {
            writer.uint32(8).int32(message.associatedFileId);
        }
        if (message.filename !== "") {
            writer.uint32(18).string(message.filename);
        }
        if (message.size !== 0) {
            writer.uint32(24).uint64(message.size);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFileUploadResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.associatedFileId = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.filename = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.size = longToNumber(reader.uint64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            associatedFileId: isSet(object.associatedFileId)
                ? globalThis.Number(object.associatedFileId)
                : isSet(object.associated_file_id)
                    ? globalThis.Number(object.associated_file_id)
                    : 0,
            filename: isSet(object.filename)
                ? globalThis.String(object.filename)
                : "",
            size: isSet(object.size) ? globalThis.Number(object.size) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.associatedFileId !== 0) {
            obj.associatedFileId = Math.round(message.associatedFileId);
        }
        if (message.filename !== "") {
            obj.filename = message.filename;
        }
        if (message.size !== 0) {
            obj.size = Math.round(message.size);
        }
        return obj;
    },
    create(base) {
        return exports.FileUploadResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFileUploadResponse();
        message.associatedFileId = object.associatedFileId ?? 0;
        message.filename = object.filename ?? "";
        message.size = object.size ?? 0;
        return message;
    },
};
exports.BigFileServiceServiceName = "powernode.BigFileService";
class BigFileServiceClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || exports.BigFileServiceServiceName;
        this.rpc = rpc;
        this.UploadFile = this.UploadFile.bind(this);
        this.DownloadBinDbFile = this.DownloadBinDbFile.bind(this);
    }
    UploadFile(request) {
        const data = request.pipe((0, operators_1.map)((request) => exports.FileUploadRequest.encode(request).finish()));
        const promise = this.rpc.clientStreamingRequest(this.service, "UploadFile", data);
        return promise.then((data) => exports.FileUploadResponse.decode(new wire_1.BinaryReader(data)));
    }
    DownloadBinDbFile(request) {
        const data = exports.DownloadBinDbFileRequest.encode(request).finish();
        const result = this.rpc.serverStreamingRequest(this.service, "DownloadBinDbFile", data);
        return result.pipe((0, operators_1.map)((data) => exports.DownloadBinDbFileResponse.decode(new wire_1.BinaryReader(data))));
    }
}
exports.BigFileServiceClientImpl = BigFileServiceClientImpl;
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
